import React from 'react';
import LoginForm from '../../components/login';


const LoginPage = () => {
  return (
    <div className="login-page">
      <div className="left-panel">
        <p className="left-text">Login to upload and receive your edited videos instantly.</p>
      </div>

      <div className="right-panel">
          {/* Use LoginForm Component here */}
          <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
